import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import {ReactElement} from "react";
import {
  AppPrimaryButton,
  AppSecondaryButton,
} from "shared/components/AppComponents";
import {CloseDialogIcon} from "assets/styles/icons";

const IdentityVerificationFailedDialog = (props: any): ReactElement => {
  const {showConfirm, onCloseForm, actionOnInitiateKYC, isInitiating} = props;

  return (
    <>
      <Dialog
        open={showConfirm}
        fullWidth
        maxWidth="sm"
        // className="account-dailog-wrapper"
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h2">Verification Failed</Typography>
            <IconButton onClick={onCloseForm}>
              <CloseDialogIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" className="f15">
            We couldn’t verify your information. Please check your details and
            try again.
          </Typography>
        </DialogContent>

        <DialogActions className="p-6">
          <AppSecondaryButton
            title="Cancel"
            className="btn-small"
            onClick={onCloseForm}
            disabled={isInitiating}
          />
          <AppPrimaryButton
            title="Try Again"
            className="btn-small"
            isLoading={isInitiating}
            disabled={isInitiating}
            loadingText="PROCESSING"
            onClick={actionOnInitiateKYC}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default IdentityVerificationFailedDialog;
